exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-no-padding-btn[data-v-70a79cbc]{padding:0!important;color:#000!important;position:absolute;right:8px}.wfh-custom-selector[data-v-70a79cbc]{width:100%;background:#fff;z-index:999;border:1px solid #eff1f5;padding:8px 0;border-radius:0 0 8px 8px!important;color:#495057;outline:0;box-shadow:0 2px 4px 0 rgba(0,0,0,.25)}.wfh-custom-selector-input[data-v-70a79cbc]{border-radius:0!important;border:1px solid #eff1f5;box-shadow:none!important}", ""]);

// exports
